var _defs, _g, _path, _path2, _path3, _path4, _path5, _g2, _path6, _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDomesticactivated(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 318,
    height: 318,
    viewBox: "0 0 318 318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_564-2",
    x: 0,
    y: 0,
    width: 318,
    height: 318,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.502
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Domestic_Component",
    "data-name": "Domestic Component",
    transform: "translate(9 6)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2751",
    "data-name": "Group 2751",
    transform: "translate(710 -515)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -719, 509)",
    filter: "url(#Rectangle_564-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564-2-2",
    "data-name": "Rectangle 564-2",
    width: 300,
    height: 300,
    transform: "translate(9 6)",
    fill: "#099"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M-484.244,599.978h4.042l8.719,10.87h9.783l-1.157,13.646,4.948,8.96h8.121l9.949,4.343,11.328,7.859-16.19-36.773-6.939-18.271-36.773,2.081-5.666,10.06Z",
    transform: "translate(707.102 -511.73)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M-461.517,679.334l-2.081,11.795,9.2,3.7h4.676l6.86,11.692,9.446-5.333,4.163-11.563,3.932-14.108,1.619-11.1-15.5,5.319-5.288-10.117-16.8,3.294Z",
    transform: "translate(705.762 -514.763)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M-448.789,635.424l-11.68,9.311-10.87,5.782,9.713,11.333,16.768-3.354,4.972-9.6,12.374-1.272-11.328-7.859Z",
    transform: "translate(706.103 -513.7)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M-486.6,636.295l-3.469,12.951,3.469,2.775,6.818,1.85,5.9-11.1,4.625,1.157-3.238,5.551,10.87-5.782,11.68-9.311h-8.121l-4.948-8.96,1.157-13.646h-9.783l-7.562,7.4-8.789-1.85-9.483,10.176,3.238,8.778Z",
    transform: "translate(707.251 -512.66)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1736",
    "data-name": "Path 1736",
    d: "M-547.567,619.5l8.557-4.394,3.559,5.781h14.711l2.775,7.4,18.04-1.62,9.483-10.176,8.789,1.85,7.562-7.4-8.719-10.87h-4.042l-9.835,2.775,5.666-10.06L-506.052,606.2l-20.815,4.857-20.585-.707-5.917,4.754Z",
    transform: "translate(709.708 -511.826)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1737",
    "data-name": "Path 1737",
    d: "M-499.44,725.251l22.434-1.388,9.019-7.632,16.19-5.551,4.894-2.762-6.86-11.692h-4.676l-9.2-3.7h-15.505l-9.935,11.333-23.822-1.388-5.551-11.1H-540.16l-15.365,34.923,5.037,6.116,21.907-18.72Z",
    transform: "translate(709.803 -516.159)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M-463.891,662.235-473.6,650.9l3.238-5.551-4.625-1.157-5.9,11.1-6.787,8.789,4.364,11.333-10.87,1.619-11.1-5.088-17.577,7.632,1.85,9.713,5.551,11.1,23.822,1.388,9.935-11.333H-466.2l2.081-11.795Z",
    transform: "translate(708.367 -514.085)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1739",
    "data-name": "Path 1739",
    d: "M-491.735,650.671l-9.483-.231-19.869-6.245-6.245,11.1-8.144,8.789,12.057,15.5,17.577-7.632,11.1,5.088,10.87-1.619-4.364-11.333,6.787-8.789-6.818-1.85Z",
    transform: "translate(708.922 -514.085)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M-558.83,630.473l4.838,12.489,9.271,7.633,22.223-7.633,19.869,6.245,9.483.231,3.469-12.951-7.632-.01-3.238-8.778-18.04,1.62-2.775-7.4h-14.712l-3.559-5.781-8.557,4.394-5.8-4.394-12.238,4.625-1.337,9.713Z",
    transform: "translate(710.332 -512.852)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M-549.8,707.326l7.5-15.958-26.879,4.887-8.607,13.385,8.607,1.549-1.438,11.634-22.2,1.387-11.449,8.9,1.619,10.639,3.238,3.238,14.8,1.387,15.727-2.081,16.254-13.89-5.037-6.116Z",
    transform: "translate(711.946 -516.159)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M-537.645,664.085l8.144-8.789,6.245-11.1-22.223,7.633-22.846,3.469,1.629,8.789,8.5,3.238-4.395,10.87-17.808,1.387L-584.8,693l7.863,14.571,8.607-13.385,26.878-4.887h17.709l-1.85-9.713Z",
    transform: "translate(711.09 -514.085)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1745",
    "data-name": "Path 1745",
    d: "M-558.453,666.3l-8.5-3.238-1.629-8.789,22.846-3.469L-555,643.174l-4.838-12.489h-8.738l1.337-9.713-17.808,1.055-5.521,18.6,9.915,6.361-1.226,8.9h-4.325l-2.544,13.876,8.095,8.789,17.809-1.387Z",
    transform: "translate(711.344 -513.065)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1746",
    "data-name": "Path 1746",
    d: "M-616.022,610.338l-9.211,2.914v11.657l11.926,2.775,3.339-11.1,17.838-6.649,5.521,10.249,17.808-1.055,12.238-4.625,5.917-4.754V586.632L-557.815,579l-28.447,4.163-31.454,18.5-8.326-1.734,2.428,4.857Z",
    transform: "translate(712.903 -511.219)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1747",
    "data-name": "Path 1747",
    d: "M-645.336,645.922l7.652-1.272-3.007-9.483,14.108-9.482V614.028l9.211-2.914-7.592-5.551-2.428-4.857V596.66l-21.046,8.095-8.326.23.694,13.646,5.781,9.02-1.02,8.152Z",
    transform: "translate(714.254 -511.996)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.5,
    style: {
      isolation: "isolate"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1748",
    "data-name": "Path 1748",
    d: "M-665.066,653.013l18.252-5.666-5.973-10.119,1.02-8.152-11.563,6.938-9.252-3.931-17.808,13.877,4.163,20.352,14.978-18.965Z",
    transform: "translate(715.732 -513.421)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1749",
    "data-name": "Path 1749",
    d: "M-582.827,646.568l-9.915-6.361,5.521-18.6-5.521-10.249-17.838,6.649-3.339,11.1-11.926-2.775-14.108,9.482,3.007,9.483,7.28,8.557,3.012,8.789H-603.6l15.224-7.169h4.325Z",
    transform: "translate(713.515 -512.642)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.1,
    style: {
      isolation: "isolate"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1750",
    "data-name": "Path 1750",
    d: "M-572.289,721.334l1.438-11.634-8.607-1.549-7.863-14.571,4.394-13.414-8.095-8.789,2.544-13.876L-603.7,664.67l-7.788,26.838,5.551,10.861-8.673,8.095-22.549-11.449-5.088,5.782,17.345,11.795,18.965,15.034,11.449-8.9Z",
    transform: "translate(713.615 -514.67)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1751",
    "data-name": "Path 1751",
    d: "M-606.891,701.9l-5.551-10.861,7.788-26.838h-23.052l-3.012-8.789-7.28-8.557-7.652,1.272-18.252,5.666,6.823,13.3.463,29.372,16.651-4.395,1.851,6.476L-615.565,710Z",
    transform: "translate(714.567 -514.202)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.25,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1752",
    "data-name": "Path 1752",
    d: "M-665.407,653.853l-6.184-5.666-14.978,18.965-11.563,21.74,3.7,17.345,7.863,10.87,11.564-.886v-8.6l16.884-11.1-.463-29.372Z",
    transform: "translate(716.072 -514.261)",
    fill: "#fff",
    stroke: "#099",
    strokeWidth: 2,
    opacity: 0.75,
    style: {
      isolation: "isolate"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1781",
    "data-name": "Path 1781",
    d: "M-620,686.082c30.195-24.549,92.2-88.5,142.492-15.891",
    transform: "translate(713.951 -515)",
    fill: "none",
    stroke: "#ffb703",
    strokeWidth: 10,
    strokeDasharray: 10
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Path_1779",
    "data-name": "Path 1779",
    transform: "translate(713.844 -509)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1788",
    "data-name": "Path 1788",
    d: "M-458.91,698h0a5.327,5.327,0,0,1-3.588-1.392l-12.846-11.7-12.845,11.7h0A5.321,5.321,0,0,1-491.777,698a5.31,5.31,0,0,1-1.922-.358,5.35,5.35,0,0,1-2.282-1.673,5.353,5.353,0,0,1-1.093-2.612,5.341,5.341,0,0,1,.379-2.8,5.342,5.342,0,0,1,1.773-2.208l12.984-9.441-7.855-7.153a3.287,3.287,0,0,1-1.023-3.052h0v0a3.287,3.287,0,0,1,2.06-2.472,3.271,3.271,0,0,1,1.189-.223,3.282,3.282,0,0,1,1.944.634l10.278,7.474,10.276-7.472a3.272,3.272,0,0,1,1.944-.635,3.317,3.317,0,0,1,1.188.22h0a3.283,3.283,0,0,1,2.061,2.472,3.283,3.283,0,0,1-1.021,3.055l-7.856,7.154,12.984,9.442a5.343,5.343,0,0,1,1.773,2.207,5.336,5.336,0,0,1,.38,2.8,5.352,5.352,0,0,1-1.093,2.613,5.353,5.353,0,0,1-2.283,1.673A5.323,5.323,0,0,1-458.91,698Z",
    fill: "#005e84",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    "data-name": "Path 1782",
    d: "M-624.483,619a24.2,24.2,0,0,0-24.2,24.2c0,10.495,14.919,26.889,21.329,33.444a4,4,0,0,0,5.662.077c.026-.025.051-.051.076-.077,6.408-6.556,21.327-22.949,21.327-33.444A24.2,24.2,0,0,0-624.483,619Zm0,35.392a11.794,11.794,0,0,1-11.792-11.8,11.793,11.793,0,0,1,11.8-11.792A11.794,11.794,0,0,1-612.688,642.6a11.793,11.793,0,0,1-11.795,11.793Z",
    transform: "translate(713.68 -514.852)",
    fill: "#005e84",
    stroke: "#fff",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "International",
    transform: "translate(710 -525)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("text", {
    id: "Domestic",
    transform: "translate(-560 803.75)",
    fill: "#fff",
    fontSize: 48,
    fontFamily: "MyriadPro-Semibold, Myriad Pro",
    fontWeight: 600,
    style: {
      isolation: "isolate"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: -98.016,
    y: 0
  }, "Domestic"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomesticactivated);
export default __webpack_public_path__ + "static/media/domesticactivated.1032a5ea62b5522d94f25ffbc3008c67.svg";
export { ForwardRef as ReactComponent };